export const parseDowntimeTextPattern = (str: string): string[] => {
  const match = str.match(/\[(.*?)]/)
  if (match) {
    return match[1].split(',').map(item => item.trim().toLowerCase())
  }
  return []
}
